import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

interface ForceUpdateScreenProps {
  message: string | null;
  storeUrl: string | null;
}

export function ForceUpdateScreen({ message, storeUrl }: ForceUpdateScreenProps) {
  const [appVersion, setAppVersion] = useState<string | null>(null);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      App.getInfo().then(info => setAppVersion(info.version)).catch(() => {});
    }
  }, []);

  const handleUpdate = () => {
    if (storeUrl) {
      if (Capacitor.isNativePlatform()) {
        window.open(storeUrl, '_system');
      } else {
        window.open(storeUrl, '_blank');
      }
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white px-6">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#3D6B4F]/10 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-[#3D6B4F]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">
          Actualización requerida
        </h1>
        <p className="text-gray-600 mb-8">
          {message || 'Hay una nueva versión disponible con mejoras importantes. Actualiza la app para continuar.'}
        </p>
        {storeUrl && (
          <button
            onClick={handleUpdate}
            className="w-full py-3 px-6 rounded-lg bg-[#3D6B4F] text-white font-semibold hover:bg-[#3D6B4F]/90 transition-colors"
          >
            Actualizar ahora
          </button>
        )}
        {appVersion && (
          <p className="mt-6 text-xs text-gray-400">Versión actual: {appVersion}</p>
        )}
      </div>
    </div>
  );
}